import { PrimaryButton, NakedButton } from '@cb/apricot-react'
import { isEmpty, formatDate, DATETIME_FORMATS } from '@myap/ui-library'
import SearchForDI from './SearchForDI'
import ModalHeader from '../_common/apricot/ModalHeader'
import ModalFooter from '../_common/apricot/ModalFooter'
import { useSaveStudentScoreSendMutation } from '../../hooks'
import { STATUS_LOADING } from '../_common/reactquery'

function OptOutButton({ nextStepFunc, disabled }) {
  return (
    <NakedButton
      small
      noPadding
      disabled={disabled}
      onClick={() => nextStepFunc(1)}
      className="cb-margin-top-24"
    >
      I&#39;m not attending college or I don&#39;t want to send a free score report
    </NakedButton>
  )
}

function SaveButton({ saveScoreSendDI, setShouldCloseModal, disabled, loading }) {
  return (
    <PrimaryButton
      small
      disabled={disabled}
      loading={loading}
      onClick={() => saveScoreSendDI({}, { onSuccess: () => setShouldCloseModal(true) })}
    >
      {loading ? 'Saving...' : 'Save'}
    </PrimaryButton>
  )
}

function ScoreSendModalStarterContent({
  nextStepFunc,
  setShouldCloseModal,
  educationPeriodCd,
  diSelectionEndDate,
}) {
  // The DI that is selected in DI Search
  const [diCodeSelection, setDICodeSelection] = useState({})
  const {
    mutate: saveScoreSendDI,
    status: saveScoreSendDIStatus,
    error,
  } = useSaveStudentScoreSendMutation({
    educationPeriodCd,
    diCode: diCodeSelection.diCode,
    org: diCodeSelection.org,
  })

  return (
    <>
      <ModalHeader isDismissable={false} title="Send Your Official AP Score Report for Free" />
      <div className="cb-modal-content">
        <p>
          Each year you take AP Exams, you can have your AP score report sent for free to one
          recipient (a college, university, or scholarship organization). Your official score report
          includes the scores from all AP Exams taken this year and any AP Exams you&#39;ve
          previously taken, along with certain demographic information about you and other
          information you provide during testing. Schools use your official score report to
          determine credit or placement, if applicable. Colleges, universities, and scholarship
          programs that you send your score to may also use your information and official score
          report to contact you with information about admissions, educational, financial aid, and
          scholarship opportunities.
        </p>
        <p>
          To send your score report, start typing in the name of a college or organization, then
          choose from the drop-down menu.
        </p>
        <div className="cb-spacerv-24" />
        <SearchForDI
          setDICodeSelection={setDICodeSelection}
          fieldName="searchSchoolOnModal"
          suggestionIdPrefix="autosuggest-on-modal-option"
        />
        {error ? (
          <Error
            className="cb-margin-bottom-24"
            title="Error saving data"
            message="Please try again later."
          />
        ) : null}
        <div className="cb-spacerv-24" />
        <p className="cb-margin-bottom-24">
          If you haven&#39;t finalized your decision on where you&#39;re attending college, select
          the school you think you&#39;re most likely to attend. You can change your recipient any
          time by{' '}
          <strong>{formatDate(diSelectionEndDate, DATETIME_FORMATS.longMonthDayYear)}</strong>, on
          the Free Score Sends page. Your score report will be sent in July.
        </p>
        <p>
          Your selected recipient receives all scores and awards that are available at the time the
          selection is processed in early July.
        </p>
        <p>
          You can see a history of all AP scores you&#39;ve sent to colleges, universities, and
          scholarship programs by clicking View Past Score Sends. Once your selection has been
          processed, you can view what date your scores were sent to the institution and which
          scores were included. We aren&#39;t able to confirm when your recipient received your
          score(s). Please contact your institution directly to inquire about receipt.
        </p>
        {OptOutButton({ nextStepFunc, disabled: saveScoreSendDIStatus === STATUS_LOADING })}
      </div>
      <ModalFooter
        actions={[
          () =>
            SaveButton({
              saveScoreSendDI,
              setShouldCloseModal,
              disabled: isEmpty(diCodeSelection) || saveScoreSendDIStatus === STATUS_LOADING,
              loading: saveScoreSendDIStatus === STATUS_LOADING,
            }),
        ]}
      />
    </>
  )
}

export default ScoreSendModalStarterContent
